import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

const TextColorDarkStyle: Stitches.CSS = {
  color: '$gray800',
};

const TextColorLightStyle: Stitches.CSS = {
  color: '$gray400',
};

const TextWeightMediumStyle: Stitches.CSS = {
  fontWeight: 500,
};

const TextWeightSemiBoldStyle: Stitches.CSS = {
  fontWeight: 600,
};

const TextWeightBoldStyle: Stitches.CSS = {
  fontWeight: 700,
};

export const TextXLContainer = styled('p', {
  fontSize: '1.8rem',
  lineHeight: '3.2rem',
  fontWeight: 400,

  ...TextColorDarkStyle,

  variants: {
    textColor: {
      light: { ...TextColorLightStyle },
      dark: { ...TextColorDarkStyle },
    },
    weight: {
      regular: {},

      medium: {
        ...TextWeightMediumStyle,
      },

      semibold: {
        ...TextWeightSemiBoldStyle,
      },

      bold: {
        ...TextWeightBoldStyle,
      },
    },
  },
});

export const TextLGContainer = styled('p', {
  fontSize: '1.6rem',
  lineHeight: '2.8rem',
  fontWeight: 400,

  ...TextColorDarkStyle,

  variants: {
    textColor: {
      light: { ...TextColorLightStyle },
      dark: { ...TextColorDarkStyle },
    },
    weight: {
      regular: {},

      medium: {
        ...TextWeightMediumStyle,
      },

      semibold: {
        ...TextWeightSemiBoldStyle,
      },

      bold: {
        ...TextWeightBoldStyle,
      },
    },
  },
});

export const TextMDContainer = styled('p', {
  fontSize: '1.4rem',
  lineHeight: '2.4rem',
  fontWeight: 400,

  ...TextColorDarkStyle,

  variants: {
    textColor: {
      light: { ...TextColorLightStyle },
      dark: { ...TextColorDarkStyle },
    },
    weight: {
      regular: {},

      medium: {
        ...TextWeightMediumStyle,
      },

      semibold: {
        ...TextWeightSemiBoldStyle,
      },

      bold: {
        ...TextWeightBoldStyle,
      },
    },
  },
});

export const TextSMContainer = styled('p', {
  fontSize: '1.2rem',
  lineHeight: '2.0rem',
  fontWeight: 400,

  ...TextColorDarkStyle,

  variants: {
    textColor: {
      light: { ...TextColorLightStyle },
      dark: { ...TextColorDarkStyle },
    },
    weight: {
      regular: {},

      medium: {
        ...TextWeightMediumStyle,
      },

      semibold: {
        ...TextWeightSemiBoldStyle,
      },

      bold: {
        ...TextWeightBoldStyle,
      },
    },
  },
});
